import { render, staticRenderFns } from "./workout-by-tabs.vue?vue&type=template&id=124e6af6&"
import script from "./workout-by-tabs.vue?vue&type=script&lang=js&"
export * from "./workout-by-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports